import React, { useState } from 'react';
import Sidebar from './components/sidebar/Sidebar';
import Topbar from './components/topbar/Topbar';
import Footer from './components/Footer';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard/Dashboard';
import SiteManagementDashboard from './pages/SiteManagement/SiteManagementDashboard';
import TermsEditor from './pages/SiteManagement/TermsEditor';
import PrivacyEditor from './pages/SiteManagement/PrivacyEditor';
import FAQManager from './pages/SiteManagement/FAQManager';
import BannerManager from './pages/SiteManagement/BannerManager';
import FeatureManager from './pages/SiteManagement/FeatureManager';
import AwardManager from './pages/SiteManagement/AwardManager';
import TestimonialManager from './pages/SiteManagement/TestimonialManager';
import LandingPageManager from './pages/SiteManagement/LandingPageManager';

import UserManagement from './pages/Users/UserManagement';
import CourseManagement from './pages/Courses/CourseManagement';
import CourseModulesPage from './pages/Modules/CourseModulesPage';
import CourseEnrollmentsPage from './pages/Enrollments/CourseEnrollmentsPage';
import ManageOrganization from './pages/Organizations/ManageOrganization';
import OrgUsers from './pages/Organizations/OrgUsers';
import OrgAdmins from './pages/Organizations/OrgAdmins';
import OrgCourses from './pages/Organizations/OrgCourses';
import OrgLicenses from './pages/Organizations/OrgLicenses';
import ManageLicenses from './pages/Licenses/ManageLicenses';
import ManageSupportTickets from './pages/SupportTickets/ManageSupportTickets';
import ForumList from './pages/Forums/ForumList';
import ForumDetail from './pages/Forums/ForumDetail';
import ForumModeration from './pages/Forums/ForumModeration';
import VltList from './pages/Vlt/VltList';
import AdminEventCalendarPage from './pages/Calendar/AdminEventCalendarPage';
import CertificateTemplatesPage from './pages/CertificateManagement/CertificateTemplatesPage';
import CourseAssignmentsPage from './pages/CertificateManagement/CourseAssignmentsPage';
import SurveyList from './pages/Surveys/SurveyList';
import SurveyForm from './pages/Surveys/SurveyForm';
import SurveyQuestions from './pages/Surveys/SurveyQuestions';
import SurveyResponses from './pages/Surveys/SurveyResponses';
import AssessmentList from './pages/Assessments/AssessmentList';
import AssessmentQuestions from './pages/Assessments/AssessmentQuestions';
import AssessmentAssignments from './pages/Assessments/AssessmentAssignments';
import AssessmentAnalytics from './pages/Assessments/AssessmentAnalytics';
import LearningJourneyList from './pages/LearningJourneys/LearningJourneyList';
import LearningJourneyForm from './pages/LearningJourneys/LearningJourneyForm';
import LearningJourneyBuilder from './pages/LearningJourneys/LearningJourneyBuilder';
import LearningJourneyEnrollments from './pages/LearningJourneys/LearningJourneyEnrollments';
import LearningJourneyReports from './pages/LearningJourneys/LearningJourneyReports';
import ManageSkills from './pages/Skills/ManageSkills';
import GlobalLearningScoreBadges from './pages/Gamification/GlobalLearningScoreBadges';
import EduGenieAdmin from './pages/EduGenie/EduGenieAdmin';
import ManageGroups from './pages/Groups/ManageGroups';
import AssignGroupUsers from './pages/Groups/AssignGroupUsers';
import AssignGroupInstructors from './pages/Groups/AssignGroupInstructors';
import ManageRoles from './pages/Roles/ManageRoles';
import AccessControl from './pages/AccessControl/AccessControl';
import ProfilePage from '../common/pages/ProfilePage';
import ChangePasswordPage from '../common/pages/ChangePasswordPage';
import VoucherManagement from './pages/Vouchers/VoucherManagement';
import VoucherUsageReport from './pages/Vouchers/VoucherUsageReport';
import CourseCompletions from './pages/Reports/CourseCompletions';
import UsersReport from './pages/Reports/UsersReport';
import EnrollmentsReport from './pages/Reports/EnrollmentsReport';
import OrganizationsReport from './pages/Reports/OrganizationsReport';
import SurveyReport from './pages/Reports/SurveyReport';
import VoucherReport from './pages/Reports/VoucherReport';
import TicketReport from './pages/Reports/TicketReport';
import TransactionsReport from './pages/Reports/TransactionsReport';
import { Offcanvas } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';

const AdminLayout = () => {
  const [sidebarShow, setSidebarShow] = useState(false);
  const isMdUp = useMediaQuery({ minWidth: 768 });

  const handleTabChange = () => {
    setSidebarShow(false); // close sidebar on mobile after navigation
  };

  return (
    <>
      <div className="container-fluid vh-100 d-flex flex-row p-0 flex flex-col md:flex-row overflow-hidden">
        {/* Sidebar for md+ screens */}
        {isMdUp && (
          <div className="fixed top-0 left-0 h-full overflow-y-auto transition-transform transform -translate-x-full md:translate-x-0 md:static md:flex-shrink-0 w-full md:w-[260px] brand-app-sidebar z-50 md:z-auto">
            <Sidebar onTabChange={handleTabChange} />
          </div>
        )}
        {/* Offcanvas Sidebar for mobile */}
        {!isMdUp && (
          <Offcanvas show={sidebarShow} onHide={() => setSidebarShow(false)} style={{ backgroundColor: '#ffffff', width: '260px' }}>
            <Offcanvas.Header closeButton style={{ borderBottomColor: '#dee2e6', backgroundColor: '#ffffff' }}>
              <Offcanvas.Title style={{ color: '#495057' }}>Admin Panel</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="p-0">
              <Sidebar onTabChange={handleTabChange} />
            </Offcanvas.Body>
          </Offcanvas>
        )}
        {/* Main Content */}
        <div className="flex-grow-1 d-flex flex-column min-vh-100 flex flex-col flex-1 overflow-y-auto bg-white/90">
          <div className="border-bottom sticky top-0 z-40 items-center justify-between shadow-md">
            <Topbar onMenuClick={() => setSidebarShow(true)} />
          </div>
          <div className="flex-grow-1 overflow-auto p-2 flex-1 overflow-y-auto sm:p-5 md:p-2 lg:p-2">
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/users" element={<UserManagement />} />
              <Route path="/courses" element={<CourseManagement />} />
              <Route path="/course-modules/:courseId" element={<CourseModulesPage />} />
              <Route path="/course-enrollments/:courseId" element={<CourseEnrollmentsPage />} />
              <Route path="/organizations" element={<ManageOrganization />} />
              <Route path="/organizations/:orgId/users" element={<OrgUsers />} />
              <Route path="/organizations/:orgId/admins" element={<OrgAdmins />} />
              <Route path="/organizations/:orgId/courses" element={<OrgCourses />} />
              <Route path="/organizations/:orgId/licenses" element={<OrgLicenses />} />
              <Route path="/licenses" element={<ManageLicenses />} />
              <Route path="/support-tickets" element={<ManageSupportTickets />} />
              <Route path="/skills" element={<ManageSkills />} />
              <Route path="/gamification" element={<GlobalLearningScoreBadges />} />
              <Route path="/edugenie" element={<EduGenieAdmin />} />
              <Route path="/groups" element={<ManageGroups />} />
              <Route path="/groups/:groupId/assign" element={<AssignGroupUsers />} />
              <Route path="/groups/:groupId/assign-instructors" element={<AssignGroupInstructors />} />
              <Route path="/roles" element={<ManageRoles />} />
              <Route path="/access-control" element={<AccessControl />} />
              <Route path="/forums" element={<ForumList />} />
              <Route path="/forums/:id" element={<ForumDetail />} />
              <Route path="/forums/moderation" element={<ForumModeration />} />
              <Route path="/vlt" element={<VltList />} />
              <Route path="/calendar" element={<AdminEventCalendarPage />} />
              <Route path="/certificates/templates" element={<CertificateTemplatesPage />} />
              <Route path="/certificates/assignments" element={<CourseAssignmentsPage />} />
              <Route path="/surveys" element={<SurveyList />} />
              <Route path="/surveys/create" element={<SurveyForm />} />
              <Route path="/surveys/:id" element={<SurveyForm />} />
              <Route path="/surveys/:id/edit" element={<SurveyForm />} />
              <Route path="/surveys/:id/questions" element={<SurveyQuestions />} />
              <Route path="/surveys/:id/responses" element={<SurveyResponses />} />
              <Route path="/assessments" element={<AssessmentList />} />
              <Route path="/assessments/:id/questions" element={<AssessmentQuestions />} />
              <Route path="/assessments/:id/assignments" element={<AssessmentAssignments />} />
              <Route path="/assessments/:id/analytics" element={<AssessmentAnalytics />} />
              <Route path="/learning-journeys" element={<LearningJourneyList />} />
              <Route path="/learning-journeys/create" element={<LearningJourneyForm />} />
              <Route path="/learning-journeys/:id/edit" element={<LearningJourneyForm />} />
              <Route path="/learning-journeys/:id/builder" element={<LearningJourneyBuilder />} />
              <Route path="/learning-journeys/:id/enrollments" element={<LearningJourneyEnrollments />} />
              <Route path="/learning-journeys/:id/reports" element={<LearningJourneyReports />} />
              <Route path="/site-management" element={<SiteManagementDashboard />} />
              <Route path="/site-management/terms" element={<TermsEditor />} />
              <Route path="/site-management/privacy" element={<PrivacyEditor />} />
              <Route path="/site-management/faqs" element={<FAQManager />} />
              <Route path="/site-management/banners" element={<BannerManager />} />
              <Route path="/site-management/features" element={<FeatureManager />} />
              <Route path="/site-management/awards" element={<AwardManager />} />
              <Route path="/site-management/testimonials" element={<TestimonialManager />} />
              <Route path="/site-management/landing-page" element={<LandingPageManager />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/change-password" element={<ChangePasswordPage />} />
              <Route path="/vouchers" element={<VoucherManagement />} />
              <Route path="/vouchers/:voucherId/usage" element={<VoucherUsageReport />} />
              <Route path="/reports/users" element={<UsersReport />} />
              <Route path="/reports/course-enrollments" element={<EnrollmentsReport />} />
              <Route path="/reports/organizations" element={<OrganizationsReport />} />
              <Route path="/reports/surveys" element={<SurveyReport />} />
              <Route path="/reports/course-completions" element={<CourseCompletions />} />
              <Route path="/reports/vouchers" element={<VoucherReport />} />
              <Route path="/reports/tickets" element={<TicketReport />} />
              <Route path="/reports/transactions" element={<TransactionsReport />} />
              <Route path="/" element={<Dashboard />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default AdminLayout;